"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_ENV_KEY = void 0;
exports.PUBLIC_ENV_KEY = '__ENV';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NjcmlwdC9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxjQUFjLEdBQUcsT0FBZ0IsQ0FBQyJ9